export enum HeaderColorEnum {
  brand = 'brand',
  background = 'background',
}
export type HeaderColorType = keyof typeof HeaderColorEnum
